import commonHttp from "./commonHttp";

/**
 * 根据园区id查询地块
 * @param params 请求的参数
 * @param params.gardenId 园区🆔
 * @returns 返回地块列表信息
 */
export function selectZdPlotList(params) {
  return commonHttp.get(`/app/selectZdPlotList?gardenId=${params.gardenId}`, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 获取用户绑定的园区信息
 * @param params 请求的参数
 * @param params.userId 用户🆔
 * @returns 返回园区列表信息
 */
export function userGarden(params) {
  return commonHttp.get(`/app/userGarden?userId=${params.userId}`, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 获取园区下的可以显示的标签
 * 通过里面的属性 isShow 来判断  "0" 为不显示，"1" 为显示
 * @param {String} gardenId 园区id
 */
export function gardenList(params) {
  return commonHttp.get(`/app/gardenList?gardenId=${params.gardenId}`, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 查询当前通用标签下的所有自定义标签
 * @param {String} dieId 用户自定义标签的die🆔
 */
export function diyList(params) {
  return commonHttp.get(`/app/diyList?dieId=${params.dieId}`, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 获取用户自定义标签下的设备列表
 * @param {String} diyId 用户自定义标签id
 * @param {Number} pageNum 页码
 * @param {Number} pageSize 每页数量
 */
export function equipmentList(params) {
  return commonHttp.get(
    `/app/equipmentList?diyId=${params.diyId}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

/**
 * 获取用户自定义标签下的设备列表
 * @param {String} id 一级设备🆔
 * @param {String} bitmapCode 设备的经纬度
 */
export function editEquipment(data) {
  return commonHttp.post(`/app/editEquipment`, data, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 获取园区设备列表
 * @param {String} gardenIds 园区🆔
 */
export function equipmentListByGardenIds(params) {
  return commonHttp.get(
    `/app/equipmentListByGardenIds?gardenIds=${params.gardenIds}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

/**
 * 获取用户权限字符集
 * @param {String} userId 用户ID
 */
export function getRoleByUserId(userId) {
  return commonHttp.get(
    `/app/getRoleByUserId/${userId}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

/**
 * 根据mac查询最新灌溉车位置
 * @param {Object} params 传参
 * @param {String} params.mac 移动灌溉设备的mac地址
 */
export function selectZdIrrigatorPositionDataNewest(params) {
  return commonHttp.get(
    `/app/selectZdIrrigatorPositionDataNewest?mac=${params.mac}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

/**
 * 根据mac查询灌溉车所有位置列表
 * @param {Object} params 传参
 * @param {String} params.mac 移动灌溉设备的mac地址
 */
export function zdIrrigatorPositionDataList(params) {
  return commonHttp.get(
    `/app/zdIrrigatorPositionDataList?mac=${params.mac}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

/**
 * 根据dieid）获取所有未绑定电子围栏 的站点信息
 * @param {Object} params 传参
 * @param {String} params.typeId 设备类型🆔
 * @param {String} params.gardenId 园区🆔
 */
export function fenceAllEquipment(params) {
  return commonHttp.get(
    `/app/fenceAllEquipment?typeId=${params.typeId}&gardenId=${params.gardenId}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

/**
 * 根据dieid）获取所有未绑定电子围栏 的站点信息
 * @param {Object} params 传参
 * @param {String} params.dieId 用户自定义标签的🆔
 */
export function fenceDiyList(params) {
  return commonHttp.get(
    `/app/fenceDiyList?dieId=${params.dieId}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

/**
 * 新增围栏
 * @param {Object} data 传参
 * @param {Number} data.gardenId 园区🆔
 * @param {Number} data.typeId 设备类型🆔
 * @param {String} data.name 围栏名称
 * @param {String} data.image 围栏的静态地图图片
 * @param {String} data.diyIds 设备站点🆔, 多个站点用逗号隔开
 * @param {String} data.address 围栏中心点转换后的地址
 * @param {String} data.code 围栏的坐标点，经纬度用逗号拼接 多个点用分号隔开 例如："116.4074,39.9042;116.4074,39.9042"
 */
export function addFence(data) {
  return commonHttp.post(`/app/addFence`, data, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 根据围栏id获取详情
 * @param {Object} params 传参
 * @param {String} params.id 围栏🆔
*/
export function getInfoFence(params) {
  return commonHttp.get(
    `/app/getInfoFence?id=${params.id}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

/**
 * 修改围栏
 * @param {Object} data 传参
 * @param {Number} data.id 围栏🆔
 * @param {Number} data.gardenId 园区🆔
 * @param {Number} data.typeId 设备类型🆔
 * @param {String} data.name 围栏名称
 * @param {String} data.image 围栏的静态地图图片
 * @param {String} data.diyIds 设备站点🆔, 多个站点用逗号隔开
 * @param {String} data.address 围栏中心点转换后的地址
 * @param {String} data.code 围栏的坐标点，经纬度用逗号拼接 多个点用分号隔开 例如："116.4074,39.9042;116.4074,39.9042"
 */
export function updateFenceById(data) {
  return commonHttp.post(`/app/updateFenceById`, data, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 删除围栏
 * @param {Object} params 传参
 * @param {String} params.id 围栏🆔
*/
export function deleteFence(params) {
  return commonHttp.get(
    `/app/deleteFence?id=${params.id}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

const api = {
  selectZdPlotList,
  userGarden,
  gardenList,
  diyList,
  equipmentList,
  editEquipment,
  equipmentListByGardenIds,
  getRoleByUserId,
  selectZdIrrigatorPositionDataNewest,
  zdIrrigatorPositionDataList,
  fenceAllEquipment,
  fenceDiyList,
  addFence,
  getInfoFence,
  updateFenceById,
  deleteFence,
};

export default api;
